import { render, staticRenderFns } from "./dep-select-widget.vue?vue&type=template&id=45ce1485&scoped=true&"
import script from "./dep-select-widget.vue?vue&type=script&lang=js&"
export * from "./dep-select-widget.vue?vue&type=script&lang=js&"
import style0 from "./dep-select-widget.vue?vue&type=style&index=0&id=45ce1485&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ce1485",
  null
  
)

export default component.exports